<template>
  <div class="demo-alignment">
    <vx-card>
      <div class="flex justify-between">
        <h1>Poll</h1>
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-play"
          @click.stop="StartPlay(respData)"
          >Play</vs-button
        >
      </div>
      <br />
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-5">
          <vs-input
            class="w-full"
            label-placeholder="Topic"
            v-model="dataTopic"
            :disabled="true"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-5">
          <vs-input
            class="w-full"
            label-placeholder="Detail"
            v-model="dataDetail"
            :disabled="true"
          />
        </div>
      </div>

      <vs-row>
        <vs-col
          vs-offset="2"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="8"
          v-for="(find, index) in typeVote"
          :key="index"
        >
          <tr>
            <td class="p-2 border border-solid d-theme-border-grey-light">
              <div class="flex flex-wrap">
                <vs-avatar size="70px" src="https://i.imgur.com/ezM6SJ5.png" />
                <vs-input
                  icon-pack="feather"
                  icon="icon-user"
                  v-model="find.detail"
                  label="Detail"
                  class="ml-10 w-1/2"
                  name="PriceAttr"
                />
                <vs-button
                  radius
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  class="mt-5 ml-10"
                  @click="deleteAttr(index)"
                ></vs-button>
              </div>
            </td>
            <br />
          </tr>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col sm:w-1/4 w-full mb-5">
          <vs-button color="primary" type="filled" @click="addAttr()"
            >Addnew Choizs</vs-button
          >
          &nbsp;
          <vs-button color="primary" type="filled" @click="submit()"
            >Save</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moduleDataList from "@/store/Poll/moduleDataList.js";

export default {
  data() {
    return {
      backgroundLoading: "#22c16b",
      dataTopic: "",
      dataDetail: "",
      typeVote: [
        {
          image: "",
          detail: "",
          count: 0,
        },
      ],
    };
  },
  computed: {
    respData() {
      return this.$store.state.poll.respDataView || [];
    },
    // respDataPoll() {
    //   return this.$store.state.poll.respData || [];
    // },
  },
  // watch: {
  //   respData(newVal,oldVal) {
  //     console.log(newVal);
  //   },
  // },
  methods: {
    StartPlay(data) {
       this.$router.push({ path: `/Poll/beforeplay/${data.key}` });
    },
    submit() {
      const obj = {
        key: this.respData.key,
        choizs: this.typeVote,
      };
      this.$vs.loading();
      this.$store
        .dispatch("poll/UpdateChoiz", obj)
        .then((res) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    deleteAttr(index) {
      this.typeVote.splice(index, 1);
    },
    addAttr() {
      this.typeVote.unshift({ image: "", detail: "", count: 0 });
    },
    // openLoadingBackground() {
    //   this.$vs.loading({
    //     background: this.backgroundLoading,
    //     color: "rgb(255, 255, 255)",
    //   });
    //   setTimeout(() => {
    //     this.$vs.loading.close();
    //   }, 3000);
    // },
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("poll", moduleDataList);
      moduleDataList.isRegistered = true;
    }
    var key = this.$route.params.id;
    // this.openLoadingBackground();
    this.$vs.loading();
    this.$store
      .dispatch("poll/ViewData", key)
      .then((res) => {
        this.dataTopic = this.respData.topic;
        this.dataDetail = this.respData.detail;
        this.typeVote = this.respData.choizs
          ? this.respData.choizs
          : this.typeVote;
        this.$vs.loading.close();
      })
      .catch((err) => {
        this.$vs.loading.close();
      });
  },
};
</script>

<style>
</style>